import React from 'react';
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from 'lucide-react';
import './SectionHeader.scss';

interface SectionHeaderProps {
  title: React.ReactNode;
  count?: string;
  actions?: React.ReactNode;
  navExtra?: React.ReactNode;
  onPrev?: () => void;
  onNext?: () => void;
  prevLabel?: string;
  nextLabel?: string;
  collapsed?: boolean;
  onToggle?: () => void;
  toggleLabel?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  count,
  actions,
  navExtra,
  onPrev,
  onNext,
  prevLabel,
  nextLabel,
  collapsed,
  onToggle,
  toggleLabel,
}) => (
  <div className={`section-header${collapsed ? ' section-header--collapsed' : ''}`}>
    <div className="section-header__nav">
      {onPrev && (
        <button className="section-header__arrow" onClick={onPrev} aria-label={prevLabel}>
          <ChevronLeft size={18} />
        </button>
      )}
      {onToggle ? (
        <button
          type="button"
          className="section-header__toggle"
          onClick={onToggle}
          aria-expanded={!collapsed}
          aria-label={toggleLabel}
        >
          <span className="section-header__title">{title}</span>
          {count && <span className="section-header__count">{count}</span>}
          {collapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
        </button>
      ) : (
        <span className="section-header__title">
          {title}
          {count && <span className="section-header__count">{count}</span>}
        </span>
      )}
      {onNext && (
        <button className="section-header__arrow" onClick={onNext} aria-label={nextLabel}>
          <ChevronRight size={18} />
        </button>
      )}
      {navExtra && <div className="section-header__nav-extra">{navExtra}</div>}
    </div>
    {actions && <div className="section-header__actions">{actions}</div>}
  </div>
);

export default SectionHeader;
